import React, { Suspense, lazy } from "react";
import Loading from "./components/Loading/Loading";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Navbar from "./components/Navbar/Navbar";

const MainPage = lazy(()=>import("./pages/MainPage/MainPage"));

const theme = createTheme({
  palette: {
    common: {
      white: "#f0f0f5",
      black: "#040118",
    },
    primary: {
      main: "#6852fc",
      // main: "#00ccff",
      // main: "#1b0d7c",
    },
    secondary: {
      main: "#fcbe52",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar />
      <Suspense fallback={<Loading />}>
        <MainPage />
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
